import {app} from '../../app';
import {RadioQuestionPreviewComponent} from "./RadioQuestionPreviewComponent";

export class BarsQuestionPreviewComponent extends RadioQuestionPreviewComponent {

}

app.component('barsQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/radioQuestionPreview.html',
    controller  : BarsQuestionPreviewComponent,
    controllerAs: 'radioQuestionPreview',
    bindings    : {
        question            : '<'
    }
});